import React , { Component } from "react"
import 'bootstrap/dist/css/bootstrap.css';
import setLanguage from 'translation';
import appconfig from "../appconfig.json";

class AfterRating extends Component{
  queryParams = new URLSearchParams(window.location.search);
     isPublic = this.queryParams.get("isPublic");
     
    componentDidMount() {
  
     // this.startCall();
      const language = localStorage.getItem("lang") ;
        setLanguage(language);
        //alert(language);
    }
    render(){
      let className = "";
    if(this.isPublic == "true"){
      className = "main-container";
    }else{
      className = "private-container";
    }
      return(
        <div id="main">
          <div className={className}>

            <div className="row">
              <div className="col-md-8">
                  <h1 data-i18n="after_rating_message_1">شكرا لمشاركتكم</h1>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                  <h1 data-i18n="after_rating_message_2">رضاكم محل اهتمامنا ونتطلع لخدمتكم بشكل افضل</h1>
              </div>
            </div>
            <a className="btn btn-primary"  data-i18n="backTohome" href={appconfig.returnHomepage}> العودة  إلى بداية الخدمة</a>
          </div>
        </div>
      );
    }
}
export default AfterRating;
